import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { filter, tap } from 'rxjs';

import { DataFilterService, FocusManagerService } from '@grid/services';
import { SelectEditComponent } from '../select-edit/select-edit.component';
import { Constants } from '@grid/utils/constants';

@UntilDestroy()
@Component({
  selector: 'app-filter-select-edit',
  templateUrl: './filter-select-edit.component.html',
  styleUrls: ['./filter-select-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterSelectEditComponent
  extends SelectEditComponent
  implements OnInit
{
  constructor(
    private dataFilterService: DataFilterService,
    private cdr: ChangeDetectorRef,
    protected focusManager: FocusManagerService
  ) {
    super(focusManager);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dataFilterService.refreshFilters$
      .pipe(
        untilDestroyed(this),
        filter(
          (message) =>
            message?.toString().toUpperCase() ===
              Constants.DefaultValues.allValues ||
            message === this.context.data.id
        ),
        tap(() => {
          this.context.data[this.context.column.columnDef] = null;

          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }
}
